import { createFileRoute } from "@tanstack/react-router";
import SamplesJournal from "@/features/harvest-journal/samples-journal";
import { JournalPage } from "@/features/harvest-journal/components/journal-page";
import { useSessionStages } from "@/features/harvest-journal/hooks/use-session-stages";

export const Route = createFileRoute("/harvests/$session_id/samples")({
  component: RouteComponent,
});

function RouteComponent() {
  const { session_id } = Route.useParams();
  const { stages } = useSessionStages(session_id);

  return (
    <JournalPage>
      <SamplesJournal sessionId={session_id} stages={stages} />
    </JournalPage>
  );
}
